<script setup>
/* Aktueller Verein eines Spielers ("Now at") in Player Info (SectorPass.vue) — Anzeige oder Auswahl aus dem
   Klubregister (ClubSelect.vue). Kein Freitext und kein eigener Logo-Upload mehr: Name und Logo kommen aus dem
   Register (supabase/klubregister-1-tabelle.sql), gepflegt vom admin im Klubregister.

   Bearbeiten darf, wer Spielerdaten schreiben darf (can('players','write')): admin, board, data. `readonly`
   erzwingt die Anzeige, z. B. solange Player Info nicht im Bearbeiten-Modus ist.
   Gewählt wird nur im Speicher: Verweis (player.currentClubId) UND Name/Logo-Pfad als Text (Übergangsregel,
   domain/footballClub.js stampClub). Gespeichert wird über den Speichern-Knopf im Panel (PlayerPanel.onSave). */
import { computed } from 'vue';
import { useAuth } from '../composables/useAuth.js';
import { useFootballClubs } from '../composables/useFootballClubs.js';
import { playerClub, stampClub } from '../domain/footballClub.js';
import ClubSelect from './ClubSelect.vue';
import ClubLogo from './ClubLogo.vue';

const props = defineProps({
  player: { type: Object, required: true },
  label: { type: String, required: true },
  readonly: { type: Boolean, default: false },
});

const { can } = useAuth();
const { byId, ensureLoaded } = useFootballClubs();
ensureLoaded();

const canEdit = computed(() => !props.readonly && can('players', 'write'));
const club = computed(() => playerClub(byId.value, props.player));

function onSelect(selected) {
  stampClub(props.player, 'currentClub', selected);
}
</script>

<template>
  <ClubSelect
    v-if="canEdit"
    class="club-field"
    :label="label"
    :model-value="player.currentClubId"
    :legacy-name="player.currentClub"
    :legacy-logo-path="player.currentClubLogoPath"
    @select="onSelect"
  />

  <div v-else class="info-item club-field">
    <label>{{ label }}</label>
    <span class="club-line">
      <ClubLogo :path="club.logoPath" :size="22" />
      {{ club.name || '—' }}
    </span>
  </div>
</template>

<style scoped>
.club-field {
  grid-column: 1 / -1;
}
.club-line {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
</style>
